import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { ReplaySubject, Observable } from 'rxjs';
import { SxHttpService } from './sxHttp.service';
import { JwtService } from './jwt.service';
import { SxSecurityService } from './sxSecurity.service';
import { AuthService } from './auth.service';


// Clave para guardar/leer el contexto en el localstorage
const  CONTEXT_LOCALSTORAGE_KEY = 'currentContext';

@Injectable()
export class SxContextService {
  private currentContextSubject = new ReplaySubject<boolean>(1);
  currentContext                = this.currentContextSubject.asObservable();
  inMemorySistema = null;
  usernameKey;

  constructor(private sxSecurity: SxSecurityService, private auth: AuthService) {
    // Cuando se hace logout remuevo el contexto que tengo en memoria
    this.sxSecurity.isAuthenticated.subscribe(isLoggedIn => {
      if (!isLoggedIn) {
        this.unloadMemory();
        this.resetLocalStorageKey();
      }
    });

    // this.auth.currentUser.subscribe(user => {
    //   this.buildLocalStorageKey(user);
    //   this.currentContextSubject.next(this.existeContexto());
    // });
  }

  /**
   * De utilidad para saber si tengo un contexto seteado
   */
  existeContexto() {
    return localStorage.getItem(CONTEXT_LOCALSTORAGE_KEY) != null;
  }

   /**
   * Obtiene el contexto, si existe
   */
  getContexto(inMemory: boolean = false): string {
    if (inMemory && this.inMemorySistema) {
      return this.inMemorySistema;
    }

    if (this.existeContexto()) {
      return localStorage.getItem(CONTEXT_LOCALSTORAGE_KEY);
    }

    return null;
  }

  /**
   * Setea un contexto
   */
  setContexto(defaultBackoffice: string, inMemory: boolean = false) {
    if (inMemory) {
      this.inMemorySistema = defaultBackoffice;
    } else {
      localStorage.setItem(CONTEXT_LOCALSTORAGE_KEY, defaultBackoffice);
    }
    this.currentContextSubject.next(true);
  }

  /**
   * Setea un contexto
   */
  removeContexto() {
    localStorage.removeItem(CONTEXT_LOCALSTORAGE_KEY);
    this.currentContextSubject.next(false);
  }

  /**
   * Resetear lo que haya guardado en la memoria
   */
  unloadMemory() {
    this.inMemorySistema = null;
  }

  private buildLocalStorageKey(user) {
    this.usernameKey = CONTEXT_LOCALSTORAGE_KEY + '_' + user.name;
  }

  private resetLocalStorageKey() {
    this.usernameKey = null;
  }

  getContext(route): Observable<any> {
    return route.params.map(params => {
      const organizationCode = params["codorganizacion"];
      const subscriptionCode = params["codsistema"];
      const channelCode = params["codnegocio"];
      const productCode = params["codproducto"];

      return {organizationCode, subscriptionCode, channelCode, productCode }
    });
  }



}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/sxContext.service.ts